import { WhatsAppSenderFields } from 'modules/graphql/types';
import { createContext, useContext } from 'react';

export type TakeoverMetadata = WhatsAppSenderFields;

export type TakeoverContextState = {
  isOpen: boolean;
  openTakeover: (metadata?: TakeoverMetadata) => void;
  closeTakeover: () => void;
  metadata: TakeoverMetadata | undefined;
};

const defaultState = {
  isOpen: false,
  openTakeover: () => null,
  closeTakeover: () => null,
  metadata: undefined,
};

export const TakeoverContext = createContext<TakeoverContextState>(defaultState);

export const useTakeoverContext = () => useContext(TakeoverContext);
